var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.683 0C.306 0 0 .388 0 .867c0 .478.306.866.683.866h12.634c.377 0 .683-.388.683-.866C14 .388 13.694 0 13.317 0H.683zm0 5.633C.306 5.633 0 6.021 0 6.5s.306.867.683.867h12.634c.377 0 .683-.388.683-.867s-.306-.867-.683-.867H.683zM0 12.133c0-.478.306-.866.683-.866h12.634c.377 0 .683.388.683.866 0 .479-.306.867-.683.867H.683C.306 13 0 12.612 0 12.133z",
    fill: "#485057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.6779dd352c7e79084928492fc7dd7da6.svg";
export { ForwardRef as ReactComponent };